import { Instant } from "@js-joda/core"

const currentVersion = import.meta.env.VITE_APP_VERSION as string

const COOLDOWN_KEY = "version-check-last-update"
const COOLDOWN_MS = 60_000
const BANNER_ID = "version-update-banner"

let bannerShown = false

async function checkForUpdate() {
  try {
    const response = await fetch("/version.json", { cache: "no-store" })
    if (!response.ok) return
    const data = await response.json()
    if (typeof data.version !== "string") return
    if (data.version !== currentVersion) {
      console.log(`[version-check] current=${currentVersion} remote=${data.version}`)
      showUpdateBanner()
    }
  } catch {
    // Network error, parse error — do nothing
  }
}

function showUpdateBanner() {
  if (bannerShown) return
  bannerShown = true

  const lastUpdate = sessionStorage.getItem(COOLDOWN_KEY)
  const withinCooldown =
    lastUpdate != null && Instant.now().toEpochMilli() - parseInt(lastUpdate) < COOLDOWN_MS

  const style = document.createElement("style")
  style.textContent = `
    @keyframes versionBannerSlideIn {
      from { transform: translateY(-100%); }
      to { transform: translateY(0); }
    }
    #${BANNER_ID} button:hover { background: #5bc0bb !important; }
  `
  document.head.appendChild(style)

  const banner = document.createElement("div")
  banner.id = BANNER_ID
  banner.style.cssText = [
    "position: fixed",
    "top: 0",
    "left: 0",
    "right: 0",
    "z-index: 99999",
    "background: #223659",
    "color: white",
    "padding: 14px 24px",
    "display: flex",
    "align-items: center",
    "justify-content: center",
    "gap: 16px",
    "font-family: system-ui, -apple-system, sans-serif",
    "font-size: 15px",
    "font-weight: 400",
    "box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15)",
    "animation: versionBannerSlideIn 0.3s ease-out",
  ].join(";")

  const text = document.createElement("span")

  if (withinCooldown) {
    text.textContent = "We’re rolling out a new version. Please try again in a few minutes."
    banner.appendChild(text)
  } else {
    text.textContent = "A new version is available."

    const button = document.createElement("button")
    button.textContent = "Update now"
    button.style.cssText = [
      "background: #6fd2cd",
      "color: #223659",
      "border: none",
      "padding: 8px 20px",
      "border-radius: 6px",
      "cursor: pointer",
      "font-size: 14px",
      "font-weight: 600",
      "font-family: inherit",
      "transition: background 0.15s",
      "white-space: nowrap",
    ].join(";")
    button.addEventListener("click", performUpdate)

    banner.appendChild(text)
    banner.appendChild(button)
  }

  document.body.prepend(banner)
}

async function performUpdate() {
  sessionStorage.setItem(COOLDOWN_KEY, String(Instant.now().toEpochMilli()))

  if ("serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations()
    for (const registration of registrations) {
      await registration.unregister()
    }
  }
  if ("caches" in window) {
    const cacheNames = await caches.keys()
    for (const name of cacheNames) {
      await caches.delete(name)
    }
  }

  window.location.reload()
}

export function setupVersionCheck() {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      checkForUpdate()
    }
  })

  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      checkForUpdate()
    }
  })

  setTimeout(checkForUpdate, 10_000)
}
